import React, { useEffect, useState } from "react";
import AccountSummary from "../EmployeeDashboard/accountsummary";
import "./MoneyCalculator.scss";
import PlanDetailsModal from "./PlanDetailsModal";

const initialValues = {
  dateRange: `Annual Return`,
  stockPayout: 0,
  totalDeduction: 0,
  loan: 0,
  taablFee: 0,
  profit: 0,
};
const MoneyCalculator = ({ plan, contributionAmount, salary }) => {
  const [showPlanDetail, setShowPlanDetail] = useState(false);
  const [transaction, setTransaction] = useState(initialValues);
  useEffect(() => {
    if (plan) {
      let discount = plan.employeeDiscount / 100;
      let contribution =
        typeof contributionAmount === "string"
          ? Number(contributionAmount)
          : contributionAmount;

      let txn = {
        dateRange: `Annual Return`,
        stockPayout: contribution / (1 - discount),
        totalDeduction: 0,
        loan: contribution,
        taablFee: contribution * 0.06,
      };
      txn.profit = txn.stockPayout - txn.loan - txn.taablFee;
      if (salary === 0) setTransaction(initialValues);
      else setTransaction(txn);
    }
  }, [plan, contributionAmount, salary]);

  if (!plan) {
    return <div>Loading...</div>;
  }
  return (
    <div className={`d-flex flex-column divcalc mt-1 mt-md-2 mt-lg-4`}>
      <div className="heading text-center">Money Calculator</div>
      <AccountSummary key={0} transaction={transaction}></AccountSummary>
      <hr className="greenHr" />
      <div className="text-center">
        <a
          className="text-primary small cursor-pointer"
          alt="plan details"
          onClick={() => setShowPlanDetail(true)}
        >
          View plan details
        </a>
      </div>
      {showPlanDetail && (
        <PlanDetailsModal
          show={showPlanDetail}
          plan={plan}
          onClose={() => setShowPlanDetail(false)}
        ></PlanDetailsModal>
      )}
    </div>
  );
};

export default MoneyCalculator;
